import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import {
  ConfigModule,
  FeaturesConfigModule,
  I18nModule, PageMetaResolver,
  provideConfig,
  UrlModule
} from '@spartacus/core';
import {
  GenericLinkModule,
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  MediaModule,
  NgSelectA11yModule, provideOutlet,
  SpinnerModule
} from '@spartacus/storefront';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GonvarriProgramClientTableModule } from './modules/gonvarri-program-client-table/gonvarri-program-client-table.module';
import { GonvarriOrderHistoryModule } from './modules/gonvarri-order-history/gonvarri-order-history.module';
import { GonvarriDownloadOrderPdfModule } from './modules/gonvarri-download-order-pdf/gonvarri-download-order-pdf.module';
import { GonvarriMyCompanyAddressesTableModule } from './modules/gonvarri-my-company-addresses-table/gonvarri-my-company-addresses-table.module';
import { GonvarriChapaQuantityModule } from './modules/gonvarri-chapa-quantity/gonvarri-chapa-quantity.module';
import { GonvarriAddToCartModule } from './modules/gonvarri-add-to-cart/gonvarri-add-to-cart.module';
import { GonvarriQuickStockTitleModalModule } from './modules/gonvarri-quick-stock-title-modal/gonvarri-quick-stock-title-modal.module';
import { GonvarriProductMultiDimensionalSelectorComponent } from './components/gonvarri-product-multi-dimensional-selector/gonvarri-product-multi-dimensional-selector.component';
import { GonvarriCategoryNavigationComponent } from './components/gonvarri-category-navigation/gonvarri-category-navigation.component';
import { GonvarriNavigationUIComponent } from './components/gonvarri-navigation-ui/gonvarri-navigation-ui.component';
import { defaultOccProductMultiDimensionalSelectorConfig } from './occ/gonvarri-occ-product-multi-dimensional-selector-config';
import { defaultB2bOccConfig } from '@spartacus/setup';
import { defaultOccOrderConfig } from './occ/gonvarri-occ-order-config';
import { translations } from '@spartacus/assets';
import { gonvarriTranslations } from './translations';
import { SmartEditConfig } from '@spartacus/smartedit/root';
import { GonvarriMiniCartModule } from './modules/gonvarri-mini-cart/gonvarri-mini-cart.module';
import { GonvarriCartSharedModule } from './modules/gonvarri-cart-shared-module/gonvarri-cart-shared-module.module';
import { defaultOccCartConfig } from './occ/gonvarri-occ-cart-config-factory';
import { GonvarriOrderExpressModule } from './modules/gonvarri-order-express/gonvarri-order-express.module';
import { ProductMultiDimensionalSelectorGuard } from './components/gonvarri-product-multi-dimensional-selector/guards/product-multi-dimensional-selector.guard';
import { GonvarriUpdatePasswordModule } from './modules/gonvarri-update-password/gonvarri-update-password.module';
import { gonvarriOccUserProfileConfig } from './occ/gonvarri-occ-user-profile-endpoint.config';
import { GonvarriResetPasswordModule } from './modules/gonvarri-reset-password/gonvarri-reset-password.module';
import { GonvarriLoginFormModule } from './modules/gonvarri-login-form/gonvarri-login-form.module';
import { GonvarriQuickStockComponent } from './components/gonvarri-quick-stock/gonvarri-quick-stock.component';
import { GonvarriLayoutConfig } from "./GonvarriLayoutConfig";
import {GonvarriQuotesModule} from "./modules/gonvarri-quotes/gonvarri-quotes.module";
import { GonvarriProductListModule } from './modules/gonvarri-product-list/gonvarri-product-list.module';
import { GonvarriProductGridItemModule } from './modules/gonvarri-product-grid-item/gonvarri-product-grid-item.module';
import {
  GonvarriUserChangePasswordFormModule
} from "./modules/gonvarri-user-change-password-form/gonvarri-user-change-password-form.module";
import {GonvarriUserDetailsModule} from "./modules/gonvarri-user-details/gonvarri-user-details.module";
import {gonvarriOccProductConfig} from "./occ/gonvarri-occ-product-config";
import {GonvarriCartTotalsModule} from "./modules/gonvarri-cart-totals/gonvarri-cart-totals.module";
import {gonvarriOccSavedCartConfigFactory} from "./occ/gonvarri-occ-saved-cart-config-factory";
import {GonvarriSavedCartListModule} from "./modules/gonvarri-saved-cart-list/gonvarri-saved-cart-list.module";
import {GonvarriOrderDetailItemsModule} from "./modules/gonvarri-order-detail-items/gonvarri-order-detail-items.module";
import {
  GonvarriOrderConsignedEntriesModule
} from "./modules/gonvarri-order-consigned-entries/gonvarri-order-consigned-entries.module";
import {
  GonvarriOrderDetailActionsModule
} from "./modules/gonvarri-order-detail-actions/gonvarri-order-detail-actions.module";
import {GonvarriAddToSavedCartModule} from "./modules/gonvarri-add-to-saved-cart/gonvarri-add-to-saved-cart.module";
import {GonvarriLoginModule} from "./modules/gonvarri-login/gonvarri-login.module";
import {GonvarriCarouselModule} from "./modules/gonvarri-carousel/gonvarri-carousel.module";
import {
  GonvarriOrderDetailReorderModule
} from "./modules/gonvarri-order-detail-reorder/gonvarri-order-detail-reorder.module";
import {GonvarriReorderModule} from "./modules/gonvarri-reorder/gonvarri-reorder.module";
import {GonvarriProductSummaryModule} from "./modules/gonvarri-product-summary/gonvarri-product-summary.module";
import { GonvarriScheduleReorderModule } from './modules/gonvarri-schedule-reorder/gonvarri-schedule-reorder.module';
import {
  GonvarriQuickStockNotificationModule
} from "./modules/gonvarri-quick-stock-notification/gonvarri-quick-stock-notification.module";
import {
  GonvarriImportEntriesDialogModule
} from "./modules/gonvarri-import-entries-dialog/gonvarri-import-entries-dialog.module";
import { B2BUserService } from '@spartacus/organization/administration/core';
import { GonvarriB2BUserService } from './core/services/gonvarri-b2b-user.service';
import {GonvarriOrderDetailsModule} from "./modules/gonvarri-order-details-module/gonvarri-order-details.module";
import {
  GonvarriCustomerTicketingModule
} from "./modules/gonvarri-customer-ticketing-module/gonvarri-customer-ticketing.module";
import {GonvarriProductPageMetaResolver} from "./core/services/gonvarri-product-page-meta.resolver";
import { GonvarriOrderConfirmationModule } from './modules/gonvarri-order-confirmation/gonvarri-order-confirmation.module';
import {defaultOccCustomerTicketingConfig} from "./occ/gonvarri-occ-customer-ticketing-config";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {UserIdInterceptor} from "./core/interceptors/user-id.interceptor";

@NgModule({
  declarations: [
    GonvarriProductMultiDimensionalSelectorComponent,
    GonvarriNavigationUIComponent,
    GonvarriCategoryNavigationComponent,
    GonvarriQuickStockComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    UrlModule,
    MediaModule,
    KeyboardFocusModule,
    NgSelectModule,
    ReactiveFormsModule,
    IconModule,
    FormsModule,
    NgSelectA11yModule,
    I18nModule,
    ItemCounterModule,
    GenericLinkModule,
    FeaturesConfigModule,
    SpinnerModule,
    ConfigModule.withConfig({
      layoutSlots: GonvarriLayoutConfig.layoutSlots,
      cmsComponents: {
        ProductMultiDimensionalSelectorComponent: {
          component: GonvarriProductMultiDimensionalSelectorComponent,
          guards: [ProductMultiDimensionalSelectorGuard],
        },
        CategoryNavigationComponent: {
          component: GonvarriCategoryNavigationComponent
        },
        GonvarriQuickStockComponent: {
          component: GonvarriQuickStockComponent,
        },
      },
      routing: {
        protected: true,
      }
    }),
    GonvarriProgramClientTableModule,
    GonvarriOrderHistoryModule,
    GonvarriDownloadOrderPdfModule,
    GonvarriMyCompanyAddressesTableModule,
    GonvarriAddToCartModule,
    GonvarriChapaQuantityModule,
    GonvarriProductGridItemModule,
    GonvarriProductListModule,
    GonvarriQuickStockTitleModalModule,
    GonvarriCartSharedModule,
    GonvarriLoginFormModule,
    GonvarriOrderExpressModule,
    GonvarriMiniCartModule,
    GonvarriUpdatePasswordModule,
    GonvarriResetPasswordModule,
    GonvarriQuotesModule,
    GonvarriUserChangePasswordFormModule,
    GonvarriUserDetailsModule,
    GonvarriCartTotalsModule,
    GonvarriSavedCartListModule,
    GonvarriOrderDetailItemsModule,
    GonvarriOrderConsignedEntriesModule,
    GonvarriOrderDetailActionsModule,
    GonvarriAddToSavedCartModule,
    GonvarriLoginModule,
    GonvarriCarouselModule,
    GonvarriOrderDetailReorderModule,
    GonvarriReorderModule,
    GonvarriProductSummaryModule,
    GonvarriCustomerTicketingModule,
    GonvarriScheduleReorderModule,
    GonvarriQuickStockNotificationModule,
    GonvarriImportEntriesDialogModule,
    GonvarriOrderDetailsModule,
    GonvarriOrderConfirmationModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserIdInterceptor,
      multi: true
    },
    {
      provide:PageMetaResolver,
      useExisting: GonvarriProductPageMetaResolver,
      multi:true
    },
    provideConfig(defaultOccProductMultiDimensionalSelectorConfig),
    provideConfig(defaultB2bOccConfig),
    provideConfig(defaultOccOrderConfig),
    provideConfig(defaultOccCartConfig),
    provideConfig(defaultOccCustomerTicketingConfig),
    provideConfig(gonvarriOccUserProfileConfig),
    provideConfig(gonvarriOccProductConfig),
    provideConfig(gonvarriOccSavedCartConfigFactory),
    { provide: B2BUserService, useClass: GonvarriB2BUserService },
    provideConfig({
      i18n: {resources: translations},
    }),
    provideConfig({
      i18n: {resources: gonvarriTranslations}
    }),
    provideConfig(<SmartEditConfig>{
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        allowOrigin: 'localhost:9002, *.*.model-t.cc.commerce.ondemand.com:443',
      },
    })
  ]
})
export class SpartacusCustomModule { }
